import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import globalParametres from '@/shared/api/globalParametres'


import i18n from '@/libs/i18n'
import _ from 'lodash'
import VueMask from 'v-mask'
import Vuelidate from 'vuelidate'
import permissionService from '@/shared/services/permissionService'
import globalMixin from '@/shared/mixins/globalMixin'
import router from './router'
import store from './store'
import App from './App.vue'
import moment from 'moment';
import excel from 'vue-excel-export'
import VueHotjar from 'vue-hotjar'

// console.log(globalParametres.hotjar.testID)

let host = window.location.host;

if (host.includes("test.bubble-in.com")) {
  Vue.use(VueHotjar, {
    id: globalParametres.hotjar.testID,
    isProduction: true,
  })
}
else if (host.includes("erp.bubble-in.com")) {
  Vue.use(VueHotjar, {
    id: globalParametres.hotjar.prodID,
    isProduction: true,
  })
}

Vue.filter('formatDate', function(value) {
  if (value) {
    moment.locale('fr')
    return moment(String(value)).format('MMMM Do YYYY, h:mm:ss a')
  }
});

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/idle'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

//VueAnalytics
// import VueAnalytics from 'vue-analytics'

// service permissions
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueMask)
Vue.use(Vuelidate)

 
Vue.use(excel)


Vue.mixin(permissionService)
Vue.mixin(globalMixin)

Object.defineProperty(Vue.prototype, '$_', { value: _ })

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
}

//vueanalytics
// Vue.use(VueAnalytics, {
//   id: 'G-Q5GJYDN3BJ'
// })

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
